import JobBoard from "./JobBoard.vue";
export default JobBoard;
